import {ChangeDetectorRef, Component, forwardRef} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractControl} from "../framework/abstract-control";
import {animate, state, style, transition, trigger} from "@angular/animations";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => FUIPinsControlComponent),
    multi: true
};

@Component({
    animations: [
        trigger("fade", [
            state("void", style({
                opacity: 0
            })),
            state("true", style({
                opacity: 1
            })),
            transition("* => *", animate("250ms 0s ease"))
        ])
    ],
    providers: [CUSTOM_VALUE_ACCESSOR],
    selector: "fui-pins-control",
    styleUrls: ["./pins-control.component.scss"],
    templateUrl: "./pins-control.component.html",
    standalone: false
})
export class FUIPinsControlComponent extends FUIAbstractControl {

    constructor(changeDetectorRef: ChangeDetectorRef) {
        super(changeDetectorRef);
    }

    /**
     *
     * @returns {boolean}
     */
    public isEmpty(): boolean {
        if (this.value) {
            if (this.value.length) {
                return false;
            }
        }

        return true;
    }
}
